import { NavLink } from "react-router-dom";
import Nav from 'react-bootstrap/Nav';
import TitleTooltip from "../helpers/TitleTooltip";
import AclRequired from "../acl/AclRequired";

const tabs = [
    {
        link: 'Inicio',
        icon: 'bi bi-house',
        nav: '/dashboard',
        acl: ['STAFF']
    },
    {
        link: 'Clientes',
        icon: 'ki-outline ki-profile-user',
        nav: '/contrato/clientes',
        acl : ['STAFF']
    },
    {
        link: 'Corte',
        icon: "bi bi-cash-coin",
        nav: '/corte/busquedas-realizadas',
        acl : ['CEO']
    },
   {
        link: 'TODO',
        icon: 'bi bi-card-checklist',
        nav: '/todo/tree',
        acl : ['CEO']
    },
    {
        link: 'Tickets',
        icon: 'bi bi-ticket-perforated',
        nav: '/tickets',
        acl : []
    },
    {
        link: 'Content',
        icon: 'ki-outline ki-feather',
        nav: '/content',
        acl : []
    },
]
export default function MainAside() {

    return (
        <>
            <div className="d-flex flex-column align-items-center flex-column-fluid w-100 pt-5 pt-lg-0" id="aside_nav">
                <div className="mb-5 scroll-ms p-5">
                    <Nav className="flex-column w-100" id="aside_nav_tabs">
                        {
                            tabs && tabs.map((t) => (
                                <AclRequired key={t.nav} flag={true} allowedRoles={t.acl}>
                                    <NavLink to={t.nav}
                                             replace={true}
                                             className={({isActive}) => (isActive ? "active " : "btn-color-gray-500 ") + " btn btn-icon mb-2 btn-active-light-primary btn-active-light"}
                                    >
                                        <TitleTooltip title={t.link} placement={'right'}>
                                            <i className={t.icon + " fs-2x"}></i>
                                        </TitleTooltip>
                                    </NavLink>
                                </AclRequired>
                            ))
                        }
                    </Nav>
                </div>
            </div>
        </>
    );
}
